import { stringifySync } from '@bingads-webui/safe-json';

import { SelectorDataSource } from './selector-data-source';

export function formatAdGroupName({ adgroupName, campaignName }) {
  return `${campaignName} > ${adgroupName}`;
}

function getEncodeDataFunction(currentCampaignName, currentCampaignId) {
  return ({
    Id,
    Name,
    CampaignName,
    CampaignId,
  }) => {
    // overwrite the current scope campaignName when encoding filter values set in a different scope
    const campaignNameToUse = CampaignName || currentCampaignName;
    // campaignId fetched from scope is string. Need to convert to int to align with filter schema.
    const campaignIdToUse = CampaignId || parseInt(currentCampaignId, 10);

    const newId = stringifySync({
      Id,
      Name,
      CampaignName: campaignNameToUse,
      CampaignId: campaignIdToUse,
    });

    return {
      Id: newId,
      Name: formatAdGroupName({ adgroupName: Name, campaignName: campaignNameToUse }),
    };
  };
}

export class AdGroupDataSource {
  constructor({
    dataContextManager,
    cacheService,
    jsdata,
    entitySet,
    currentCampaignName,
    currentCampaignId,
  }) {
    this.selectorDataSource = new SelectorDataSource({
      dataContextManager,
      cacheService,
      dataSource: jsdata.AdGroup,
      type: 'adgroup',
      selectorLoadAction: 'adgroupselector/load?',
      entitySet,
      encodeData: getEncodeDataFunction(currentCampaignName, currentCampaignId),
    });
  }

  get itemsDisplayLimit() {
    return this.selectorDataSource.itemsDisplayLimit;
  }

  get(viewFilter, searchFilter, ids) {
    return this.selectorDataSource.get(viewFilter, searchFilter, ids);
  }

  getByIds(ids) {
    return this.selectorDataSource.getByIds(ids);
  }
}
